export default "__VITE_ASSET__ByseilsZ__"